import STATUS_MAPPING from 'routes/Expenses/utils/statusMapping'

export const getIsDescriptionAvailable = (status) =>
  ['Need More Info', 'Declined'].includes(status)

export const getTextByStatus = (status) =>
  STATUS_MAPPING[status] || 'Save and Do not notify'
